export default function PlusIcon() {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 7.49999H12.8548M6.92742 1.57257V13.4274"
        stroke="currentColor"
        strokeWidth="1.97581"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
